import { gql } from '@apollo/client';

/**
 * Saved-screen writes.
 *
 * `saveScreen` keeps a screen that has already been RUN: it names an existing
 * result by its `urlId`, rather than taking a set of filters. So a screen is
 * created by running the screener and keeping the answer — which is why this
 * app can list, read and delete screens but does not offer a "new screen"
 * button that could not work.
 */
export const SAVE_SCREEN = gql`
  mutation SaveScreen($name: String!, $urlId: String!) {
    saveScreen(name: $name, urlId: $urlId) {
      success
      message
      screenId
    }
  }
`;

export const DELETE_SCREEN = gql`
  mutation DeleteScreen($screenId: Int!) {
    deleteScreen(screenId: $screenId) {
      success
      message
      screenId
    }
  }
`;
